/**
 *
 * @param {import('../types').UpcNumberBopsMap} selectedBopsData
 * @param {import('@common-vue/media-card-large/src/composables/useUpc/types').UseUpc.Upc} selectedUpcData
 * @param {boolean} marketplaceFlag
 * @returns {import('../types').Pickup}
 */
function generatePickupData(
  selectedBopsData,
  selectedUpcData,
  marketplaceFlag = false,
) {
  const {
    availability = {
      lowAvailability: false,
      bopsAvailability: false,
      bossAvailability: false,
      isBossUpc: false,
      availabilityMessage: '',
    },
  } = selectedBopsData;
  const { availability: upcAvailability = { orderType: '' } } = selectedUpcData;

  return {
    ...availability,
    orderType: upcAvailability?.orderType,
    bossAvailabilityMessage: availability.availabilityMessage,
    marketplaceItemFlag: marketplaceFlag,
  };
}

/**
 * @param {import('../types').UpcNumberSddMap} selectedSddData
 * @param {import('@common-vue/media-card-large/src/composables/useUpc/types').UseUpc.Upc} selectedUpcData
 * @returns {import('../types').Ship}
 */
function generateShipData(
  selectedSddData,
  selectedUpcData,
) {
  const {
    availability = {
      available: false,
      lowAvailability: false,
      availabilityMessage: '',
      message: '',
      orderType: '',
    }, marketplaceFlag = false,
  } = selectedUpcData;
  const { sddAvailability = false } = selectedSddData;

  return {
    ...availability,
    sddAvailability,
    marketplaceItemFlag: marketplaceFlag,
    sellerName: selectedUpcData?.seller?.sellerName || '',
  };
}

/**
 * @param {{
 *  selectedRadioButton: string,
 *  availabilityData: import('../types').bopsAvailabilityXapiResponce
 *  selectedUpcId?: string,
 *  upcData: import('@common-vue/media-card-large/src/composables/useUpc/types').UseUpc.UpcData
 *  product: Product | undefined,
 * }} param0
 * @returns {import('../types').ProductInfo}
 */
export const productInfoParser = ({
  selectedRadioButton = 'ShipIt',
  availabilityData,
  selectedUpcId = '',
  upcData,
  product,
}) => {
  const {
    upcNumberBopsMap = {},
    sddStore: shipFromStore = {},
    upcNumberSddMap = {},
  } = availabilityData;

  const { id = '', detail } = product || {};
  const { deliveryDays } = product?.relationships.upcs?.[selectedUpcId] || { deliveryDays: {} };
  const selectedUpcData = upcData?.upcs?.[selectedUpcId] || {};
  const { number: selectedUpcNumber, marketplaceFlag } = selectedUpcData;

  const selectedBopsData = upcNumberBopsMap[+selectedUpcNumber] || {};
  const selectedSddData = upcNumberSddMap[+selectedUpcNumber] || {};

  const pickup = generatePickupData(selectedBopsData, selectedUpcData, marketplaceFlag);
  const ship = generateShipData(selectedSddData, selectedUpcData);
  const upcNumber = selectedUpcData?.number;

  return {
    selectedRadioButton,
    selectedUpcId,
    productId: `${id}`,
    productName: detail?.name || '',
    isEGiftCard: false,
    bagItemId: '',
    pickup,
    ship,
    deliveryDays,
    shipFromStore: {
      ...shipFromStore,
      orderCutoffTime: shipFromStore?.orderCutOffTime || '',
    },
    upcNumber,
  };
};

export default productInfoParser;
